module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-3.c74cb72d.webp";